export const SystemModuleType = {
  Reservations: "Reservations",
  TimeClock: "TimeClock",
  AiAgents: "AiAgents",
  FiscalIntegration: "FiscalIntegration",
  Delivery: "Delivery",
  WhatsAppAutomation: "WhatsAppAutomation",
  WhatsAppCrm: "WhatsAppCrm",
  WhatsAppOfficial: "WhatsAppOfficial",
  RespostaAi: "RespostaAi",
  Promotions: "Promotions",
  Awards: "Awards",
  Coupons: "Coupons",
  Notices: "Notices",
  ExtraServices: "ExtraServices",
  StoreGroups: "StoreGroups",
  PushNotifications: "PushNotifications",
  PrintAutomation: "PrintAutomation",
  ManualExternalOrders: "ManualExternalOrders",
  CustomerExitCheck: "CustomerExitCheck",
  ReservedOrders: "ReservedOrders",
  Checklists: "Checklists",
} as const

export type SystemModuleType = (typeof SystemModuleType)[keyof typeof SystemModuleType]
